import { calculators } from '../../../mocks/calculators';

export default function CalculatorsSection() {
  const calculatorRoutes: Record<string, string> = {
    'income-tax': '/calculator/income-tax',
    'deduction-finder': '/calculator/deduction-finder',
    'refund': '/calculator/refund',
    'w2-vs-1099': '/calculator/w2-vs-1099',
    'self-employment': '/calculator/self-employment',
    'capital-gains': '/calculator/capital-gains',
    'quarterly-tax': '/calculator/quarterly-tax',
    'withholding': '/calculator/withholding',
    'retirement': '/calculator/retirement',
    'state-comparison': '/calculator/state-comparison'
  };

  return (
    <section className="py-20 bg-gradient-to-br from-gray-50 to-white" id="calculators" aria-labelledby="calculators-heading">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 id="calculators-heading" className="text-4xl font-bold text-gray-900 mb-4">
            <strong>Free Tax Calculators</strong>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Powerful tools to estimate your taxes, find deductions, and plan your financial future
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {calculators.map((calc) => (
            <a
              key={calc.id}
              href={calculatorRoutes[calc.id]}
              className="bg-white rounded-2xl p-8 shadow-sm hover:shadow-2xl border border-gray-100 hover:border-teal-500 transition-all duration-300 hover:-translate-y-2 cursor-pointer group"
            >
              <div className="w-16 h-16 flex items-center justify-center bg-gradient-to-br from-teal-500 to-teal-600 rounded-xl mb-6 group-hover:scale-110 transition-transform duration-300 shadow-lg">
                <i className={`${calc.icon} text-3xl text-white`}></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-3 group-hover:text-teal-600 transition-colors leading-tight">
                {calc.title}
              </h3>
              <p className="text-gray-600 leading-relaxed mb-6 text-base">{calc.description}</p>
              <div className="flex items-center text-teal-600 font-semibold group-hover:gap-3 gap-2 transition-all">
                <span className="whitespace-nowrap">Calculate Now</span>
                <i className="ri-arrow-right-line text-lg"></i>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}